<!-- Button to toggle mega menu -->
<button mat-icon-button (click)="toggleMegaMenu()">

  @if (!showMegaMenu) {
    <mat-icon>expand_more</mat-icon>
  }
  @if (showMegaMenu) {
    <mat-icon>expand_less</mat-icon>
  }
</button>
<!-- *ngIf="showMegaMenu" -->
<!-- Mega Menu Container -->
@if (showMegaMenu) {
  <div class="mega-menu" @fadeSlideIn>
    <div class="mega-menu-container" (mouseleave)="showMegaMenu = false">
      <div class="mega-menu-grid">
        <!-- Left: App List -->
        <div class="mega-menu-app-list" >
          @for (app of myapps; track app; let i = $index) {
            <div class="app-tab" [class.active]="i === selectedAppIndex"
              (click)="selectApp(i)">
              <span class="app-icon" [ngClass]="app.style?.iconClass"></span>
              <div class="app-info">
                <div class="app-title">{{ app.name }}</div>
                <div class="app-subtitle">{{ app.subTitle }}</div>
              </div>
            </div>
          }
        </div>
        <!-- Center: Selected App Menus -->
        @if (selectedApp) {
          <div class="mega-menu-app-content">
            <h3>{{ selectedApp.title }}</h3>
            <p>{{ selectedApp.subtitle }}</p>
            <div class="menu-groups">
              @for (group of selectedApp.menuGroup; track group) {
                <div class="menu-group" >
                  @if (group.menuGroup && group.menuItem) {
                    <div class="menu-group">
                      <div class="menu-group-header">
                        <div class="menu-avatar">{{ getAvatarInitials(group.name) }}</div>
                        <strong>{{ group.name }} </strong>
                      </div>
                      @if (group.menuItem?.length) {
                        <ul>
                          @for (item of group.menuItem; track item) {
                            <li class="{{selectedPage == item ? 'menu-ctive' : ''}}" >
                              @if (item.pageId) {
                                <a [routerLink]="getNamedPageUrl(item, null)" (click)="toggleActive(item,selectedApp.appId)">
                                  {{ item.name }} @if (selectedPage == item ) {
                                  <span  class="active-span"> <mat-icon >check_circle_outline</mat-icon></span>
                                }
                              </a>
                            }
                          </li>
                        }
                      </ul>
                    }
                  </div>
                }
                @if (!group.menuGroup) {
                  <div>
                    <a [routerLink]="getNamedPageUrl(group, null)" (click)="toggleActive(group)">
                      {{ group.name }}
                    </a>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
      <!-- Right: App Image -->
      <div class="mega-menu-app-image">
        <!-- *ngIf="!selectedApp.image" -->
        @if (wordCloudWords) {
          <div class="word-cloud-circle" >
            @for (word of wordCloudWords; track word; let i = $index) {
              <span
                class="cloud-word"
                [ngStyle]="getWordPosition(i, wordCloudWords.length)"
                >
                {{ word }}
              </span>
            }
          </div>
        }
        <!-- <img src="https://fingresscdn.azureedge.net/cdn/illustrations/svg/status_update_jjgk.svg?v:1.2.3"
        alt="{{ selectedApp.title }}" /> -->
      </div>
    </div>
  </div>
</div>
}